import { Expose, Type } from 'class-transformer';
import { SopWithRelationshipResponseDto } from '../complaints-process-config/sop-relationship.dto';

export class PvProcessConfigResponseDto {
    /**
     * Pharmacovigilance process configuration ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Client Information Record ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * AE Assessment Organization ID
     * @example '123e4567-e89b-12d3-a456-426614174001'
     */
    @Expose()
    aeAssessmentOrganizationId?: string;

    /**
     * Email for AE reporting
     * @example 'ae.reports@example.com'
     */
    @Expose()
    aeReportingEmail?: string;

    /**
     * PMS Organization ID
     * @example '123e4567-e89b-12d3-a456-426614174002'
     */
    @Expose()
    pmsOrganizationId?: string;

    /**
     * Email for PMS activities
     * @example 'pms@example.com'
     */
    @Expose()
    pmsEmail?: string;

    /**
     * Literature Search Organization ID
     * @example '123e4567-e89b-12d3-a456-426614174003'
     */
    @Expose()
    literatureSearchOrganizationId?: string;
    @Expose()
    qncConductingGvpSelfInspection?: boolean;
    @Expose()
    gvpSelfInspectionFrequency?: string;

    /**
     * Notes on PV process
     * @example 'Q&C not involved for AE assessment'
     */
    @Expose()
    notes?: string;

    /**
     * Creation timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    createdAt: Date;

    /**
     * Last update timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    updatedAt: Date;

    @Expose()
    @Type(() => SopWithRelationshipResponseDto)
    sops?: SopWithRelationshipResponseDto[];
}
